import { render, staticRenderFns } from "./TermsAmendmentModal.vue?vue&type=template&id=38168e96&scoped=true&"
import script from "./TermsAmendmentModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./TermsAmendmentModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TermsAmendmentModal.vue?vue&type=style&index=0&id=38168e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38168e96",
  null
  
)

export default component.exports